import React from 'react'
import ReactDOM from 'react-dom'

import InfoNotificationComponent from './components/notification'
import GrowlCollection from '../../../core/gd-model/growl/growl-collection'
import GrowlModel from '../../../core/gd-model/growl/growl'
import Growl from '../../../core/gd-model/growl/growl'
import {GrowlType, Message} from "./@types"
import VScroll from "../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"


// export default class GrowlApp extends React.Component{
export default class AppGrowl {

    public notificationsList : GrowlCollection = new GrowlCollection([]);
    public popoverContainer  : string = "body"
    public idSeed            : number = 0
    public _popoverElement   : any

    constructor() {
        // this.popoverContainer = ""
    }

    init() {
        // this.popoverContainer = "body";
    }

    clientCreated(id: ID, title: string, type: GrowlType) {
        return this.addNotification(GrowlType.CLIENT_CREATED, {
            id:     id,
            title:  title,
            type:   type,
        }, true, false);
    }

    customerCreated(id: ID, title: string) {
        return this.addNotification(GrowlType.CUSTOMER_CREATED, {
            id:     id,
            title:  title,
        }, true, false);
    }

    taskCreated(id: ID, title: string, shortId: ID) {
        return this.addNotification(GrowlType.TASK_CREATED, {
            id: id,
            title: title,
            shortId: shortId
        }, true, false);
    }

    eventCreated(id: ID, title: string) {
        return this.addNotification(GrowlType.EVENT_CREATED, {
            id: id,
            title: title,
        }, true, false);
    }

    chatMessage(chatId: ID, fromUserId: ID, message: Message) {
        return this.addNotification(GrowlType.CHAT_MESSAGE, {
            chatId: chatId,
            fromUserId: fromUserId,
            message: message
        }, true, false);
    }

    automationCreated(id: ID) {
        return this.addNotification(GrowlType.AUTOMATION_CREATED, {
            id: id,
        }, true, false);
    }

    automationApplied(id: ID) {
        return this.addNotification(GrowlType.AUTOMATION_APPLIED,{
            id: id,
        }, true, false);
    }

    actionApplied(id: ID, hasAccess: boolean) {
        return this.addNotification(GrowlType.ACTION_APPLIED,{
            id          : id,
            hasAccess   : hasAccess,
        }, true, false)
    }

    actionRunFailed(id: ID, errorMessage: string, hasAccess: boolean) {
        return this.addNotification(GrowlType.ACTION_RUN_FAILED,{
            id              : id,
            errorMessage    : errorMessage,
            hasAccess       : hasAccess,
        }, true, true)
    }

    rateExperience() {
        this.addNotification(GrowlType.RATE_EXPERIENCE, {}, false, true);
    }

    openLinksInDesktopApp() {
        this.addNotification(GrowlType.OPEN_LINKS_IN_DESKTOP_APP, {}, false, true);
    }

    reminderCreated(id: ID, title: string) {
        return this.addNotification(GrowlType.REMINDER_CREATED, {
            id: id,
            title: title,
        }, true, false);
    }

    info(message: Message) {
        return this.addNotification(GrowlType.INFO, message, true, false);
    }

    success(message: any) {
        return this.addNotification(GrowlType.SUCCESS, message, true, false);
    }

    successSticky(message: Message | string) {
        return this.addNotification(GrowlType.SUCCESS, message, true, true);
    }

    error(message?: any) {
        // if (!message) message = "Oops, something went wrong. Refresh the page and try again.";
        return this.addNotification(GrowlType.ERROR, message, false, true);
    }

    warning(message: any) {
        // if (!message) message="Oops, something went wrong. Refresh the page and try again.";
        return this.addNotification(GrowlType.WARNING, message, true, true);
    }

    connectionError(message: Message) {
        // if (!message) message="You have been disconnected from the server.";
        return this.addNotification(GrowlType.CONNECTION_ERROR, message, false, true);
    }

    addNotification(type: GrowlType, message: any, selfDestroy: boolean, isSticky: boolean) {
        let infoNotification = new GrowlModel({
            id          : "notification-id-" + this.idSeed++,
            type        : type,
            message     : message,
            isSticky    : isSticky,
            selfDestroy : selfDestroy
        });
        this.notificationsList.add(infoNotification);
        this.renderNotifications();
        return infoNotification;
    }

    removeNotification(model: Growl) {
        this.notificationsList.remove(model.id);
        this.renderNotifications();
    }

    removeAllButSticky() {
        this.notificationsList.models.filter(function(model: Growl){
            return !model.isSticky;
        }).map((model: Growl)=>{
            this.notificationsList.remove(model.id);
        });

        this.renderNotifications();
    }

    removeAll() {
        const notifications = this.notificationsList.models.slice()
        _.map(notifications, (model)=>{
            this.notificationsList.remove(model.id)
        })
        this.renderNotifications()
    }

    renderNotifications() {

        if (!this._popoverElement) {
            let popover = document.createElement( "span" );
            popover.className = "growl";
            this._popoverElement = popover;
            document.querySelector(this.popoverContainer)?.appendChild( popover );
        }

        let notifications = _.clone(this.notificationsList.models); //.reverse();

        const style = {
            maxHeight: gd.layout.height
        }

        // const isEmpty = _.size(notifications) === 0;
        //
        // const classes = Classes("growl-container", {
        //     'p-t-10 p-r-10 p-b-20 p-l-20'  : !isEmpty // other wise it will take space ...
        // })

        ReactDOM.render(
            <VScroll containerClass="growl-container" containerStyle={style}>
                {_.map(notifications, (infoNote: Growl)=> {
                    return <InfoNotificationComponent key={infoNote.id} data={infoNote}/>
                })}
            </VScroll>,
            this._popoverElement
        )
    }
}
